import React, { useState, useEffect, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDashboard, faList } from "@fortawesome/free-solid-svg-icons";
import "../../assets/styles/barhide.css";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { Link } from "react-router-dom";
import NfsmSidebar from "../Common/NfsmSidebar";
import axios from "axios";
import MaterialReactTable from "material-react-table";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { ExportToCsv } from "export-to-csv"; //or use your library of choice here
import { set } from "date-fns/esm";
import { useNavigate } from "react-router-dom";

  function NFSMFarmersOutcomesUploadedReport() {
  const navigate = useNavigate();
  const [statesData, setStatesData] = useState([]);
  const [districtData, setDistrictData] = useState([]);
  const [subDistrictData, setSubDistrictData] = useState([]);
  const [blockData, setBlockData] = useState([]);
  const [villageData, setVillageData] = useState([]);

  const [stateValue, setStateValue] = useState("");
  const [districtValue, setDistrictValue] = useState("");
  const [subDistrictValue, setSubDistrictValue] = useState("");
  const [blockValue, setBlockValue] = useState("");
  const [villageValue, setVillageValue] = useState("");

  const [yearValue, setYearValue] = useState("");
  const [seasonValue, setSeasonValue] = useState("");
  const [cropGroupValue, setCropGroupValue] = useState("");
  const [cropNameValue, setCropNameValue] = useState("");
  const [cropVarietyValue, setCropVarietyValue] = useState("");

  const [cropGroupData, setCropGroupData] = useState([]);
  const [cropNameData, setCropNameData] = useState([]);
  const [cropVarietyData, setCropVarietyData] = useState([]);

  const [nfsmData, setNfsmData] = useState([]);
  const [isFetching, setIsFetching] = useState(true);

  const columns = useMemo(() => [
    {
      header: "S.No",
      Cell: (cell) => Number(cell.row.id) + 1,
      size: 1
    },
    {
      accessorKey: "cropDemonstrationCode",
      header: "CFLD ID",
    },
    {
      accessorKey: "seasonName",
      header: "Season Name",
    },
    {
      accessorKey: "stateName",
      header: "State",
    },
    {
      accessorKey: "districtName",
      header: "District",
    },
    {
      accessorKey: "blockName",
      header: "Block",
    },
    {
      accessorKey: "villageName",
      header: "Village",
    },
    {
      accessorKey: "cropGroupName",
      header: "Crop Group",
    },

    {
      accessorKey: "cropName",
      header: "Crop Name",
    },
    {
      accessorKey: "cropVarietyName",
      header: "Crop Variety",
    },
   
    {
      accessor: '',
      header: "Total Area Covered (Ha)",
      Cell: cell => <><span>{cell.row.original.totalAreaHA === null ? "0" : cell.row.original.totalAreaHA} </span> </> 
         
  },
    {
      accessorKey: "totalNoofFarmers",
      header: "Total Number of Farmers",
    },
    {
      accessor: '',
      header: 'Farmers Uploaded Outcomes',
      Cell: cell =>   <i className="btn text-primary" type="button" onClick={() => navigate("/farmerandcropwisereport", { state: { cropSurveyCode: cell.row.original, status: 1} })}><span>{cell.row.original.farmerUploadedOutcomes}</span></i>
         
  },
  
  {
    accessor: '',
    header: "Farmers haven’t Uploaded Outcomes",
    Cell: cell =>   <i className="btn text-primary" type="button" onClick={() => navigate("/farmerandcropwisereport", { state: { cropSurveyCode: cell.row.original, status: 0 } })}><span>{cell.row.original.farmerNotUploadedOutcomes}</span></i>
       
},

  ]);

  useEffect(() => {
    const cropGroup = async () => {
      const result = await axios(`https://nfsm.gov.in/NFSMAPI/api/GetCommonDDL`);
      setCropGroupData(result.data.dataContent);
    };

    cropGroup();
    fetchData();
  }, []);

  const fetchData = async (params) => {
    setIsFetching(true);
    const result = await axios.post(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/Reverse/NFSMMISDashbard/Get_NFSM_MIS_Dashboard_OutcomesUploaded`,
      {
        finYear: params === "reset" ? "" : yearValue,
        season: params === "reset" ? "" : seasonValue,
        cropGroup: params === "reset" ? "" : cropGroupValue,
        cropCode: params === "reset" ? "" : cropNameValue,
        cropVarietyCode: params === "reset" ? "" : cropVarietyValue,
        stateCode: params === "reset" ? "" :  stateValue,
        districtCode: params === "reset" ? "" : districtValue,
        blockCode: params === "reset" ? "" : blockValue,
        villageCode: params === "reset" ? "" :  villageValue,
        case : 3
      }
    );
    if(result.data.data) {
      setNfsmData(result.data.data);
      setIsFetching(false);
    }else {
      setNfsmData([]);
      setIsFetching(false);
    }
   
  };

  const cropName = async (value) => {
    setCropGroupValue(value);

    const result = await axios.post(
      `${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Reverse/NFSMMISDashbard/NFSMCropName`,
      {
        "nfsmCropGroupCode": value,
      }
    );
    setCropNameData(result.data.data);
  };

  const cropVariety = async (value) => {
    setCropNameValue(value);
    const result = await axios.post(
      `${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Management/CommCropVariety/getCropVarietyExtList`,
      {
        // "cropGroupCode": cropGroupValue,
        cropCode: value,
      }
    );
    setCropVarietyData(result.data.dataContent);
  };

  function getStates() {
    const fetchStates = async () => {
      const result = await axios(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/states`
      );
      setStatesData(result.data.dataContent);
    };
    fetchStates();
  }

  function handleState(value) {
    setStateValue(value);
    if (value === "NA") {
      return;
    }
    setDistrictData([]);
    setDistrictValue("");
    // setSubDistrictValue("");

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      stateCode: Number(value),
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/district`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => setDistrictData(JSON.parse(result).dataContent))
      .catch((error) => console.log("error", error));
  }

  function handleSubDistrict(value, DDValue) {
    setDistrictValue(value);

    if (value === "NA") {
      return;
    }
    if (value != null) {
      var raw = JSON.stringify({
        // subdistrictcode: value,
        districtcode: value,
      });
    } else {
      var raw = JSON.stringify({
        // subdistrictcode: value,
        districtcode: districtValue,
      });
    }

    // setSubDistrictValue(value);
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/subdistrict`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => setSubDistrictData(JSON.parse(result).dataContent))
      .catch((error) => console.log("error", error));
  }
  function handleBlock(value) {
    setDistrictValue(value);
    if (value === "NA") {
      return;
    }

    var raw = JSON.stringify({
      // subdistrictcode: value,
      districtcode: value,
    });

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/block`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => setBlockData(JSON.parse(result).dataContent))
      .catch((error) => console.log("error", error));
  }

  function handleVillage(value) {
    // setSubDistrictValue(value);
    console.log("block code", blockValue);
    if (value === "NA") {
      return;
    }

    var raw = JSON.stringify({
      blockcode: blockValue,
    });

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/village`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => setVillageData(JSON.parse(result).dataContent))
      .catch((error) => console.log("error", error));
  }

  // Below Code is use to download table data as CSV
  const handleExportData = () => {
    const csvOptions = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      useBom: true,
      useKeysAsHeaders: false,
      headers: Object.keys(nfsmData[0]),
    };

    const csvExporter = new ExportToCsv(csvOptions);
    csvExporter.generateCsv(nfsmData);
  };

  function handleReset() {
    setStateValue("");
    setDistrictValue("");
    setSubDistrictValue("");
    setBlockValue("");
    setVillageValue("");

    setYearValue("");
    setSeasonValue("");
    setCropGroupValue("");
    setCropNameValue("");
    setCropVarietyValue("");

    fetchData("reset");
  }

  return (
    <>
      <NfsmSidebar />
      <div className="page-wrapper chiller-theme toggled">
        <main id="main" className="main ">
          <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
            <nav>
              <h1>NFSM Reports</h1>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">Admin</li>
                <li className="breadcrumb-item active">Crop Wise Number</li>
              </ol>
            </nav>
            <Link className="btn btn-success" to="/SchemeReports">
              Schemes
            </Link>
          </div>
          <div className="container-fluid">
            <div className="card">
              <div className="card-body onbordedSchemess schemesreport">
                <div className="row">
                  <div className="col-md-12">
                    <h3>
                    Farmers Outcomes Uploaded – Consolidated
                    </h3>
                  </div>
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-2 mb-2">
                        <label htmlFor="year" className="form-label">
                          Financial Year
                        </label>
                        <select
                          className="form-select"
                          onChange={(e) => setYearValue(e.target.value)}
                          value = {yearValue}
                        >
                          <option defaultValue>Choose...</option>
                          <option value="17">2021-2022</option>
                          <option value="18">2022-2023</option>
                          <option value="19">2023-2024</option>
                        </select>
                      </div>

                      <div className="col-md-2">
                        <label htmlFor="season" className="form-label">
                          Season
                        </label>
                        <select
                          className="form-select"
                          onChange={(e) => setSeasonValue(e.target.value)}
                          value={seasonValue}
                        >
                          <option defaultValue>Choose...</option>
                          <option value="1">Kharif</option>
                          <option value="2">Rabi</option>
                          <option value="3">Early Kharif</option>
                          <option value="4">Summer</option>
                        </select>
                      </div>

                      <div className="col-md-2">
                        <label htmlFor="cropGroup" className="form-label">
                          Crop Group
                        </label>
                        <select
                          id="cropGroup"
                          required
                          className="form-select"
                          // onClick={cropName}
                          onChange={(e) => cropName(e.target.value)}
                          value={cropGroupValue}
                        >
                          <option defaultValue>Choose...</option>
                          <option value="3">Pulse</option>
                          <option value="13">Nutri Cereals</option>
                          <option value="27">Oilseeds</option>
                          {/* {cropGroupData
                            ? cropGroupData.map((item, id) => {
                                return (
                                  <option key={id} value={item.cropGroupCode}>
                                    {" "}
                                    {item.cropGroupName}
                                  </option>
                                );
                              })
                            : ""} */}
                        </select>
                      </div>

                      <div className="col-md-2">
                        <label htmlFor="cropName" className="form-label">
                          Crop Name
                        </label>
                        <select
                          id="cropName"
                          required
                          className="form-select"
                          // onClick={getDesignation}
                          onChange={(e) => cropVariety(e.target.value)}
                          value={cropNameValue}
                        >
                          <option defaultValue>Choose...</option>
                          {cropNameData
                            ? cropNameData.map((item, id) => {
                                return (
                                  <option key={id} value={item.nfsmCropCode}>
                                    {" "}
                                    {item.nfsmCropName}
                                  </option>
                                );
                              })
                            : ""}
                        </select>
                      </div>

                      <div className="col-md-2">
                        <label htmlFor="cropVariety" className="form-label">
                          Crop Varietry
                        </label>
                        <select
                          id="cropVarietry"
                          required
                          className="form-select"
                          // onClick={getDesignation}
                          onChange={(e) => setCropVarietyValue(e.target.value)}
                          value={cropVarietyValue}
                        >
                          <option defaultValue>Choose...</option>
                          {cropVarietyData
                            ? cropVarietyData.map((item, id) => {
                                return (
                                  <option key={id} value={item.cropVarietyCode}>
                                    {" "}
                                    {item.cropVarietyName}
                                  </option>
                                );
                              })
                            : ""}
                        </select>
                      </div>

                      <div className="col-md-2">
                        <label
                          htmlFor="State"
                          className="form-label"
                          id="StateLabel"
                        >
                          State
                        </label>
                        <select
                          id="State"
                          required
                          className="form-select"
                          onClick={getStates}
                          onChange={(e) => handleState(e.target.value)}
                          value={stateValue}
                          name="stateCode"
                        >
                          <option defaultValue value="NA">
                            Choose...
                          </option>
                          {statesData
                            ? statesData.map((item, id) => {
                                return (
                                  <option key={id} value={item.stateCode}>
                                    {" "}
                                    {item.stateName}
                                  </option>
                                );
                              })
                            : ""}
                        </select>
                      </div>
                      <div className="col-md-2">
                        <label
                          htmlFor="District"
                          className="form-label"
                          id="DistrictLabel"
                        >
                          District
                        </label>
                        <select
                          id="District"
                          className="form-select"
                          onChange={(e) => handleBlock(e.target.value)}
                          value={districtValue}
                        >
                          <option defaultValue value="NA">
                            Choose...
                          </option>

                          {districtData
                            ? districtData.map((item, id) => {
                                return (
                                  <option key={id} value={item.districtCode}>
                                    {" "}
                                    {item.districtName}
                                  </option>
                                );
                              })
                            : ""}
                        </select>
                      </div>
                      {/* <div className="col-md-2">
                        <label
                          htmlFor="subDistrict"
                          className="form-label"
                          id="subDistrictLabel"
                        >
                          SubDistrict
                        </label>
                        <select
                          id="subDistrict"
                          className="form-select"
                          onChange={(e) => handleBlock(e.target.value)}
                          value={subDistrictValue}
                        >
                          <option defaultValue value="NA">
                            Choose...
                          </option>

                          {subDistrictData.map((item, id) => {
                            return (
                              <option key={id} value={item.subDistrictCode}>
                                {" "}
                                {item.subDistrictName}
                              </option>
                            );
                          })}
                        </select>
                      </div> */}
                      {/* <div className="col-md-2">
                        <label
                          htmlFor="Block"
                          className="form-label"
                          id="BlockLabel"
                        >
                          Block
                        </label>
                        <select
                          id="Block"
                          className="form-select"
                          onClick={handleVillage}
                          onChange={(e) => setBlockValue(e.target.value)}
                          value={blockValue}
                        >
                          <option defaultValue value="NA">
                            Choose...
                          </option>
                          {blockData
                            ? blockData.map((item, id) => {
                                return (
                                  <option key={id} value={item.blockCode}>
                                    {" "}
                                    {item.blockName}
                                  </option>
                                );
                              })
                            : ""}
                        </select>
                      </div> */}
                      {/* <div className="col-md-2">
                        <label htmlFor="inputVillage" className="form-label">
                          Village
                        </label>
                        <select
                          id="Village"
                          className="form-select"
                          // onClick={handleVillage}
                          onChange={(e) => setVillageValue(e.target.value)}
                          value={villageValue}
                        >
                          <option defaultValue value="NA">
                            Choose...
                          </option>
                          {villageData
                            ? villageData.map((item, id) => {
                                return (
                                  <option key={id} value={item.villageCode}>
                                    {" "}
                                    {item.villageName}
                                  </option>
                                );
                              })
                            : ""}
                        </select>
                      </div> */}
                      <div className="col-md-2 mt-4 filterbtn">
                      
                        <button
                          type="submit"
                          className="btn btn-submit btn-success"
                          onClick={fetchData}
                        >
                          Filter
                        </button>{" "}
                        &nbsp;
                        <button
                          type="submit"
                          className="btn btn-outline-secondary"
                          onClick={handleReset}
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 ">
              <div className="card">
                <MaterialReactTable
                  columns={columns}
                  data={nfsmData}
                  enableColumnOrdering
                  enablePagination={true}
                  state={{ isLoading: isFetching ? true : false }}
                  renderTopToolbarCustomActions={({ table }) => (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "1rem",
                        p: "0.5rem",
                        flexWrap: "wrap",
                      }}
                    >
                      <Button
                        color="primary"
                        //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                        onClick={handleExportData}
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export in CSV
                      </Button>
                    </Box>
                  )}
                />
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default NFSMFarmersOutcomesUploadedReport;
